import { render, staticRenderFns } from "./PainelInfraTic.vue?vue&type=template&id=ddc67ab8"
import script from "./PainelInfraTic.vue?vue&type=script&lang=js"
export * from "./PainelInfraTic.vue?vue&type=script&lang=js"
import style0 from "./PainelInfraTic.vue?vue&type=style&index=0&id=ddc67ab8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports